import React from 'react';
import { Checkbox, Col, Row, Form, Tooltip } from 'antd';
import { CalculateFreeServices } from '../../../model/api-modules/price-calculator';
import './style.scss';
import getFormatMessage from '../../../locales/get-format-message';
import { SERVICES_LIST } from '../service-list';

interface IProps {
  readonly selectedServices: { [key: string]: string[] };
  readonly setSelectedServices: React.Dispatch<
    React.SetStateAction<{
      [key: string]: string[];
    }>
  >;
  readonly supportServicesList: string[];
  readonly isSelectIngame: boolean;
}

export const ServiceSelectForm = (props: IProps) => {
  const handleCategoryChange = (
    category: string,
    checked: boolean,
    options: string[]
  ) => {
    const supportOptions: string[] = [];
    options.forEach((item) => {
      if (
        props.supportServicesList.indexOf(item) !== -1 &&
        checkFreeServices(item)
      ) {
        supportOptions.push(item);
      }
    });
    props.setSelectedServices((prev) => ({
      ...prev,
      [category]: checked ? supportOptions : [],
    }));
  };

  const handleOptionChange = (category: string, values: string[]) => {
    props.setSelectedServices((prev) => ({
      ...prev,
      [category]: values,
    }));
  };

  const isCategorySelected = (category: string, options: string[]) => {
    const supportOptions: string[] = [];
    options.forEach((item) => {
      if (
        props.supportServicesList.indexOf(item) !== -1 &&
        checkFreeServices(item)
      ) {
        supportOptions.push(item);
      }
    });
    return props.selectedServices[category]?.length === supportOptions.length;
  };

  const checkFreeServices = (service: string) => {
    const freeServices: string[] = [];
    for (const value of Object.values(CalculateFreeServices)) {
      freeServices.push(value);
    }
    // 非免费服务或者免费服务但是选中了ingame计费服务返回true可选
    return !freeServices.includes(service) || props.isSelectIngame;
  };

  const isCategoryDisabled = (options: string[]) => {
    const supportOptions: string[] = [];
    options.forEach((item) => {
      if (props.supportServicesList.indexOf(item) !== -1) {
        supportOptions.push(item);
      }
    });
    return supportOptions.length === 0;
  };

  const isIndeterminate = (category: string, options: string[]) => {
    const supportOptions: string[] = [];
    options.forEach((item) => {
      if (
        props.supportServicesList.indexOf(item) !== -1 &&
        checkFreeServices(item)
      ) {
        supportOptions.push(item);
      }
    });
    return (
      supportOptions.length !== 0 &&
      props.selectedServices[category]?.length !== 0 &&
      props.selectedServices[category]?.length < supportOptions.length
    );
  };

  return (
    <Form className="price-services-form">
      {SERVICES_LIST.map((serviceGroup) => (
        <div key={serviceGroup.category} className="price-services-box">
          <Row className="price-services-left">
            <Col>
              {isCategoryDisabled(
                serviceGroup.options.map((opt) => opt.value)
              ) ? (
                <Tooltip title={getFormatMessage('price_not_support')}>
                  <Checkbox
                    checked={isCategorySelected(
                      serviceGroup.category,
                      serviceGroup.options.map((opt) => opt.value)
                    )}
                    disabled={true}
                    onChange={(e) =>
                      handleCategoryChange(
                        serviceGroup.category,
                        e.target.checked,
                        serviceGroup.options.map((opt) => opt.value)
                      )
                    }
                    indeterminate={isIndeterminate(
                      serviceGroup.category,
                      serviceGroup.options.map((opt) => opt.value)
                    )}
                  >
                    {serviceGroup.category}
                  </Checkbox>
                </Tooltip>
              ) : (
                <Checkbox
                  checked={isCategorySelected(
                    serviceGroup.category,
                    serviceGroup.options.map((opt) => opt.value)
                  )}
                  onChange={(e) =>
                    handleCategoryChange(
                      serviceGroup.category,
                      e.target.checked,
                      serviceGroup.options.map((opt) => opt.value)
                    )
                  }
                  indeterminate={isIndeterminate(
                    serviceGroup.category,
                    serviceGroup.options.map((opt) => opt.value)
                  )}
                >
                  {serviceGroup.category}
                </Checkbox>
              )}
            </Col>
          </Row>
          <Checkbox.Group
            value={props.selectedServices[serviceGroup.category] || []}
            onChange={(values) =>
              handleOptionChange(serviceGroup.category, values as string[])
            }
            style={{ width: '100%' }}
            className="price-services-right"
          >
            <Row gutter={[20, 20]}>
              {serviceGroup.options.map((option) => (
                <Col key={option.value} span={6}>
                  {props.supportServicesList.indexOf(option.value) === -1 ||
                  !checkFreeServices(option.value) ? (
                    <Tooltip
                      title={
                        !checkFreeServices(option.value)
                          ? getFormatMessage('price_additional_services')
                          : getFormatMessage('price_not_support')
                      }
                    >
                      <Checkbox value={option.value} disabled={true}>
                        {option.label}
                      </Checkbox>
                    </Tooltip>
                  ) : (
                    <Checkbox value={option.value}>{option.label}</Checkbox>
                  )}
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </div>
      ))}
    </Form>
  );
};
